import { CommonModel } from '@telialt/models/src/CommonModel';
import { datadogLogger } from '@telialt/utils/src/datadog/datadogLogger';
import { DDComponent } from '@telialt/utils/src/datadog/setup';

import { apiGetSearchQuery } from '../../api';
import { SEARCH_HELP_SUGGESTIONS_COUNT } from '../../constants';
import { HelpSearchItem, SearchQueryKeysMap, SearchQueryParams } from '../../model';
import { getQueryKeyPrefixBySegment } from '../../utils/segment';

type Params = {
    searchText: string;
    segment: CommonModel.Segment;
    queryKeys: SearchQueryKeysMap;
    signal?: AbortSignal;
};

export const loadHelpSuggestions = async ({ searchText, segment, queryKeys, signal }: Params) => {
    const queryKeyPrefix = getQueryKeyPrefixBySegment(segment);

    const searchParams: SearchQueryParams = {
        searchText,
        offset: 0,
        limit: SEARCH_HELP_SUGGESTIONS_COUNT,
    };

    try {
        const response = await apiGetSearchQuery<HelpSearchItem>(
            queryKeys[`${queryKeyPrefix}-help`],
            searchParams,
            signal,
        );

        return { help: response.data };
    } catch (error) {
        datadogLogger().warn(error, { component: DDComponent.Search });

        return { error };
    }
};
